<template>
<div>
    <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
    >
    </comment-header>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="0" style="display:flex;align-items:center">
            <!-- <a-col :span="5"> -->
              <a-form-item label="账号">
                <a-input v-model="queryParam.account" placeholder="" style="width:240px;margin-right:20px" />
              </a-form-item>
            <!-- </a-col> -->
            <!-- <a-col :span="5"> -->
              <a-form-item label="类型">
                <a-select v-model="queryParam.type" placeholder="请选择" default-value="0" style="width:240px;margin-right:20px">
                  <a-select-option value="0" key="0">全部</a-select-option>
                  <a-select-option value="1" key="1">管理员</a-select-option>
                  <a-select-option value="2" key="2">普通用户</a-select-option>
                </a-select>
              </a-form-item>
            <!-- </a-col> -->

            <!-- <a-col :span="6"> -->
              <a-form-item label="所属企业">
                <a-select v-model="queryParam.enterpriseId" placeholder="请选择" default-value="0" style="width:240px;margin-right:20px"> 
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option v-for="d in enterpriseList" :key="d.value">
                    {{ d.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            <!-- </a-col> -->
            <!-- <a-col :span="3"> -->
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <!-- <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button> -->
              </span>
            <!-- </a-col> -->
          </a-row>
        </a-form>
      </div>

      <div class="table-operator" style="margin:20px">
        <a-button type="primary" icon="plus" @click="handleCreate()">新建</a-button>
      </div>

      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :rowSelection="options.rowSelection"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <span slot="configFtp" slot-scope="text, record, index">
          {{ text==false?'否':'是' }}
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
          </template>
          <!-- <template>
            <a @click="handleRemove(record)">删除</a>
            <a-divider type="vertical" />
          </template> -->
          <template>
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item @click="handleRemove(record)"><a>删除</a></a-menu-item>
                <a-menu-item v-if="record.type != 1" @click="auth(record)"><a>授权项目</a></a-menu-item>
                <a-menu-item v-if="record.configFtp == false" @click="addconfigFtp(record)" ><a>创建FTP权限</a></a-menu-item>
                <a-menu-item v-if="record.configFtp != false" @click="editconfigFtp(record)" ><a>修改FTP权限</a></a-menu-item>
              </a-menu>
              <a>更多<a-icon type="down" /></a>
            </a-dropdown>
          </template>
        </span>
      </s-table>
      <user-form
        ref="userForm"
        :title="title"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        :enterpriseList="enterpriseList"
        @cancel="handleCancel"
        @ok="handleOk"
      />
      <authorize-project
        ref="authorizeProject"
        :title="title2"
        :visible="visible2"
        :loading="confirmLoading2"
        :v-model="mdl"
        :projectList="projectList"
        @cancel="handleCancel2"
        @ok="handleOk2"
      />
    </a-card>
    <a-modal
      title="添加FTP"
      :visible="addFTPshow"
      @ok="addFTPhandleOk"
      @cancel="addFTPhandleCancel"
      okText="确定"
      cancelText="取消"
    >
      <a-checkbox-group :options="FTPoptions" v-model="addFTP" style="marginLeft:100px">
      </a-checkbox-group>
    </a-modal>
    <a-modal
      title="修改FTP"
      :visible="editFTPshow"
      @ok="editFTPhandleOk"
      @cancel="editFTPhandleCancel"
      okText="确定"
      cancelText="取消"
    >
      <a-checkbox-group :options="FTPoptions" v-model="editFTP" style="marginLeft:100px">
      </a-checkbox-group>
    </a-modal>
</div>
</template>

<script>
import CommentHeader from "@components/header";
import moment from 'moment'
import  STable  from '@components/STable'
import * as userManagement from '@api/userManagement'
import { getAllEnterprise } from '@api/enterpriseManagement'
import * as projectManagement from '@api/projectManage'
import UserForm from './UserForm'
import AuthorizeProject from './AuthorizeProject'

const FTPoptions = [
  { label: '启用', value: 'enableflag' },
  { label: '写入权限', value: 'writepermission' },
];
export default {
  name: 'UserManagement',
  components: {
    STable,
    UserForm,
    AuthorizeProject,
    CommentHeader
  },
  data() {
    return {
      writepermission:false,
      enableflag:false,
      id:'',
      editFTP:[],
      FTPoptions,
      addFTP:['enableflag'],
      editFTPshow:false,
      addFTPshow:false,
      fathertitle: '系统管理',
      childtitle: '用户管理',
      path:'/train/system/user-list',  
      visible: false,
      confirmLoading: false,
      mdl: null,
      title: '',
      visible2: false,
      confirmLoading2: false,
      mdl2: null,
      title2: '选择授权项目',
      currentUserId: '',
      recordData: {},
      enterpriseList: [],
      projectList: [],
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '账号',
          dataIndex: 'account',
        },
        {
          title: '真实姓名',
          dataIndex: 'realName',
        },
        {
          title: '职务',
          dataIndex: 'postion',
        },
        {
          title: '类型',
          dataIndex: 'userTypeName',
          needTotal: true,
        },
        {
          title: '所属企业',
          dataIndex: 'enterpriseName',
          needTotal: true,
        },
        {
          title: '是否拥有FTP权限',
          dataIndex: 'configFtp',
          scopedSlots: { customRender: 'configFtp' },
          align:'center'
        },
        {
          title: '新建时间',
          dataIndex: 'createTime',
          sorter: true,
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log('loadData.parameter', parameter)
        return userManagement.getUserPageList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res.data
        })
      },
      selectedRowKeys: [],
      selectedRows: [],

      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          },
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
        },
      },
      optionAlertShow: false,
    }
  },
  created() {
    this.initEnterpriseList()
    this.initProjectList()
    this.tableOption()
  },
  methods: {
    editFTPhandleCancel(){
      this.editFTPshow = false
    },
    editFTPhandleOk(){
      if(this.editFTP.includes('enableflag')){
        this.enableflag = true
      }
      if(this.editFTP.includes('writepermission')){
        this.writepermission = true
      }
      userManagement.updateFtp({
        id:this.id,
        enableflag:this.enableflag,
        writepermission:this.writepermission
      }).then((res) => {
        this.editFTPshow = false
        this.enableflag = false
        this.writepermission = false
      })
      
    },
    addFTPhandleOk(){
      if(this.addFTP.includes('enableflag')){
        this.enableflag = true
      }
      if(this.addFTP.includes('writepermission')){
        this.writepermission = true
      }
      userManagement.addFtp({
        id:this.id,
        enableflag:this.enableflag,
        writepermission:this.writepermission
      }).then((res) => {
        console.log(res);
        this.addFTPshow = false
        this.enableflag = false
        this.writepermission = false
      })
      
    },
    addFTPhandleCancel(){
      this.addFTPshow = false
      this.addFTP = ['enableflag']
    },
    addconfigFtp(record){
      this.id = record.id
      this.addFTPshow = true
    },
    editconfigFtp(record){
      this.id = record.id
      userManagement.getFtp(record.id).then((res) => {
        const arr = []
        console.log(res);
        if(res.data.enableflag == true){
          arr.push('enableflag')
        }
        if(res.data.writepermission == true){
          arr.push('writepermission')
        }
        this.editFTP = arr
        this.editFTPshow = true
      })
    },
    handleCreate() {
      this.title = '新增'
      this.currentUserId = ''
      this.mdl = {
        enterpriseId: this.enterpriseList.length > 0 ? this.enterpriseList[0].value : null,
      }
      this.visible = true
    },
    handleEdit(record) {
      this.title = '编辑'
      this.currentUserId = record.id
      const self = this
      userManagement.getUser(record.id).then((res) => {
        console.log(res)
        self.mdl = { ...res.data }
        self.visible = true
      })
    },
    handleCancel() {
      this.visible = false
      const form = this.$refs.userForm.form
      if (form != undefined) form.resetFields()
    },

    handleOk() {
      const form = this.$refs.userForm.form
      this.confirmLoading = true
      const self = this
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)

          if (self.currentUserId != '') {
            // 修改 e.g.
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve()
              }, 500)
            }).then((res) => {
              userManagement.updateUser({ ...values, id: self.currentUserId }).then((r) => {
                self.visible = false
                self.confirmLoading = false
                // 重置表单数据
                form.resetFields()
                // 刷新表格
                self.$refs.table.refresh()
                self.$message.info('修改成功')
              })
            })
          } else {
            // 新增
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve()
              }, 500)
            }).then((res) => {
              userManagement.addUser({ ...values }).then((r) => {
                self.visible = false
                self.confirmLoading = false
                // 重置表单数据
                form.resetFields()
                // 刷新表格
                self.$refs.table.refresh()
                this.$message.info('新增成功')
              })
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    auth(record) {
      const self = this
      this.title2 = '选择需要授权的项目'
      this.currentUserId = record.id
       const form = this.$refs.authorizeProject.form
      this.visible2 = true
      this.mdl = {}

      projectManagement.getProjectIdsByUser(record.id).then((res) => {
        this.mdl.projectIds=res.data
         form.setFieldsValue({projectIds:res.data})
      })
    },
    handleCancel2() {
      this.visible2 = false
      const form = this.$refs.authorizeProject.form
      if (form != undefined) form.resetFields()
    },
    handleOk2() {
      const form = this.$refs.authorizeProject.form
      this.confirmLoading2 = true
      const self = this
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          const vv = []
  
          for (let index = 0; index < values.length; index++) {
            const element = values[index]
          }

          // 修改 e.g.
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          }).then((res) => {
            projectManagement.setAuth({ userId: self.currentUserId, ...values }).then((r) => {
              self.visible2 = false
              self.confirmLoading2 = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              self.$message.info('项目授权成功')
            })
          })
        } else {
          this.confirmLoading2 = false
        }
      })
    },
    handleRemove(record) {
      const self = this
      this.$confirm({
        title: `你想要删除此项吗?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: "确认",
        cancelText: "取消",
        onOk() {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
            .then((res) => {
              userManagement.removeUser({ id: record.id }).then((r) => {
                self.$refs.table.refresh()
              })
            })
            .catch(() => console.log('小猪，出错啦，休息会吧!'))
        },
        autoFocusButton: null,
      })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            },
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
          },
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null,
        }
        this.optionAlertShow = false
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      // this.advanced = !this.advanced
    },

    resetSearchForm() {
      this.queryParam = {
        date: moment(new Date()),
      }
    },
    initEnterpriseList() {
      const self = this
      getAllEnterprise().then((res) => {
        res.data.forEach((r) => {
          self.enterpriseList.push({
            value: r.id,
            text: r.name,
          })
        })
      })
    },
    initProjectList() {
      const self = this
      projectManagement.getAllProject().then((res) => {
        res.data.forEach((r) => {
          self.projectList.push({
            value: r.id,
            text: r.name,
          })
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ant-card-body {
  padding: 0;
}
</style>
